import { c as _c } from "react/compiler-runtime";
import type { ApiWaveLog } from "@/generated/models/ApiWaveLog";
import { formatNumberWithCommas, getTimeAgoShort } from "@/helpers/Helpers";
import Link from "next/link";
import Image from "next/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import { WaveLeaderboardRightSidebarActivityLogDrop } from "./WaveLeaderboardRightSidebarActivityLogDrop";
import type { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
import { SystemAdjustmentPill } from "@/components/common/SystemAdjustmentPill";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
interface WaveLeaderboardRightSidebarActivityLogProps {
  readonly log: ApiWaveLog;
  readonly creditType: ApiWaveCreditType;
  readonly onDropClick: () => void;
}
export const WaveLeaderboardRightSidebarActivityLog: React.FC<WaveLeaderboardRightSidebarActivityLogProps> = t0 => {
  const $ = _c(51);
  const {
    log,
    creditType,
    onDropClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FontAwesomeIcon icon={faClock} className="tw-size-3.5 tw-flex-shrink-0 tw-text-iron-400" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== log.created_at) {
    t2 = getTimeAgoShort(new Date(log.created_at).getTime());
    $[1] = log.created_at;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="tw-flex tw-items-center tw-gap-1.5">{t1}<span className="tw-text-xs tw-font-medium tw-text-iron-400">{t2}</span></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onDropClick) {
    t4 = <WaveLeaderboardRightSidebarActivityLogDrop onDropClick={onDropClick} />;
    $[5] = onDropClick;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-justify-between">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `/${log.invoker.handle ?? log.invoker.primary_address}`;
  const t7 = `Voter: ${log.invoker.handle ?? log.invoker.primary_address}`;
  let t8;
  if ($[10] !== log.invoker.pfp) {
    t8 = log.invoker.pfp ? <Image src={resolveIpfsUrlSync(log.invoker.pfp)} alt="" width={20} height={20} className="tw-size-5 tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-white/10" /> : <div className="tw-size-5 tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-white/10" />;
    $[10] = log.invoker.pfp;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = log.invoker.handle ?? log.invoker.id;
  let t10;
  if ($[12] !== log.invoker.handle) {
    t10 = <span className="tw-text-sm tw-font-medium tw-text-iron-50 tw-transition-all tw-duration-300 desktop-hover:group-hover:tw-text-iron-300">{log.invoker.handle}</span>;
    $[12] = log.invoker.handle;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <UserProfileTooltipWrapper user={t9}>{t10}</UserProfileTooltipWrapper>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t12 = <Link href={t6} className="tw-group tw-flex tw-items-center tw-gap-2 tw-no-underline tw-transition-all tw-duration-300 desktop-hover:hover:tw-opacity-80" title={t7}>{t8}{t11}</Link>;
    $[17] = t11;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== log.contents.oldVote) {
    t13 = log.contents.oldVote === 0 ? <span className="tw-text-sm tw-text-iron-400">voted</span> : <span className="tw-whitespace-nowrap tw-text-sm tw-text-iron-500">{formatNumberWithCommas(log.contents.oldVote)} →</span>;
    $[22] = log.contents.oldVote;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = `tw-whitespace-nowrap tw-text-sm tw-font-semibold ${log.contents.newVote > 0 ? "tw-text-green" : "tw-text-red"}`;
  let t15;
  if ($[24] !== log.contents.newVote) {
    t15 = formatNumberWithCommas(log.contents.newVote);
    $[24] = log.contents.newVote;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = WAVE_VOTING_LABELS[creditType];
  let t17;
  if ($[26] !== t14 || $[27] !== t15 || $[28] !== t16) {
    t17 = <span className={t14}>{t15}{" "}{t16}</span>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== log.contents.reason) {
    t18 = log.contents.reason === "CREDIT_OVERSPENT" && <SystemAdjustmentPill />;
    $[30] = log.contents.reason;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t13 || $[33] !== t17 || $[34] !== t18) {
    t19 = <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-x-1.5 tw-overflow-hidden">{t13}{t17}{t18}</div>;
    $[32] = t13;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  const t20 = `/${log.drop_author?.handle ?? log.drop_author?.primary_address}`;
  const t21 = `Drop creator: ${log.drop_author?.handle ?? log.drop_author?.primary_address}`;
  let t22;
  let t23;
  if ($[36] !== log.drop_author) {
    t22 = log.drop_author?.pfp ? <Image src={resolveIpfsUrlSync(log.drop_author.pfp)} alt="" width={20} height={20} className="tw-size-5 tw-flex-shrink-0 tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-white/10" /> : <div className="tw-size-5 tw-flex-shrink-0 tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-white/10" />;
    t23 = log.drop_author?.handle ? <UserProfileTooltipWrapper user={log.drop_author.handle}><span className="tw-text-sm tw-font-medium tw-text-iron-50 tw-transition-all tw-duration-300 desktop-hover:group-hover:tw-text-iron-300">{log.drop_author.handle}</span></UserProfileTooltipWrapper> : <span className="tw-text-sm tw-font-medium tw-text-iron-50 tw-transition-all tw-duration-300 desktop-hover:group-hover:tw-text-iron-300">{log.drop_author?.handle}</span>;
    $[36] = log.drop_author;
    $[37] = t22;
    $[38] = t23;
  } else {
    t22 = $[37];
    t23 = $[38];
  }
  let t24;
  if ($[39] !== t20 || $[40] !== t21 || $[41] !== t22 || $[42] !== t23) {
    t24 = <Link href={t20} className="tw-group tw-flex tw-items-center tw-gap-2 tw-no-underline tw-transition-all tw-duration-300 desktop-hover:hover:tw-opacity-80" title={t21}>{t22}{t23}</Link>;
    $[39] = t20;
    $[40] = t21;
    $[41] = t22;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t12 || $[45] !== t19 || $[46] !== t24) {
    t25 = <div className="tw-mt-1.5 tw-flex tw-flex-wrap tw-items-center tw-gap-2">{t12}{t19}{t24}</div>;
    $[44] = t12;
    $[45] = t19;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t25 || $[49] !== t5) {
    t26 = <div className="tw-relative"><div className="tw-rounded-lg tw-bg-iron-900 tw-p-3">{t5}{t25}</div></div>;
    $[48] = t25;
    $[49] = t5;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  return t26;
};